import { useLang } from "@/contexts/LanguageContext";
import { Plus } from "lucide-react";

export function FaqList({ items, testIdPrefix = "faq-item" }) {
  return (
    <div className="divide-y divide-slate-200 border-t border-b border-slate-200">
      {items.map((it, i) => (
        <details key={it.q} className="faq-item group py-5" data-testid={`${testIdPrefix}-${i}`}>
          <summary className="flex items-center justify-between gap-6">
            <span className="font-serif text-xl lg:text-2xl text-[#0B192C] leading-snug">{it.q}</span>
            <Plus className="faq-icon h-5 w-5 text-[#C2A878] shrink-0" strokeWidth={1.5} />
          </summary>
          <p className="mt-4 text-slate-600 leading-relaxed max-w-3xl">{it.a}</p>
        </details>
      ))}
    </div>
  );
}

export default function Faq() {
  const { t } = useLang();
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16 lg:py-24" data-testid="faq-page">
      <p className="eyebrow">{t.faq.eyebrow}</p>
      <h1 className="font-serif text-4xl sm:text-5xl mt-4 text-[#0B192C] leading-tight" data-testid="faq-title">{t.faq.title}</h1>
      <div className="mt-12">
        <FaqList items={t.faq.items} testIdPrefix="faq-page-item" />
      </div>
    </div>
  );
}
